<template>
    <div class="match" v-bind:class="{ _live: match.isLive, tournamentCenter: isShowTournamentCenterMatchInfo }">
        <MtMatchDisplay v-bind:match="match" />
        <MtMatchFunction v-bind:match="match" />
    </div>
</template>

<script lang="ts" setup>
    import { type PropType, computed, toRefs } from 'vue';
    import MtMatchDisplay from '@/components/match/muayThai/MtMatchDisplay.vue';
    import MtMatchFunction from '@/components/match/muayThai/MtMatchFunction.vue';
    import type { IMatch } from '@/interface/IMatch';
    import { isShowTournamentCenterMatchInfo as _isShowTournamentCenterMatchInfo } from '@/libraries/composables/useZone';

    const props = defineProps({
        match: {
            type: Object as PropType<IMatch>,
            required: true,
        },
    });

    const { match } = toRefs(props);
    const isShowTournamentCenterMatchInfo = computed(() => _isShowTournamentCenterMatchInfo(match.value.leagueName));
</script>

<style lang="scss" scoped>
@import "@/scss/components/match";

.match.tournamentCenter {
    background-image: url("@/assets/images/tournament-center/BgMatchCardTitleSeaGames2025.png"), linear-gradient(90deg, #001995 0%, #0049b3 100%);
    background-position: right top, 0 0;
    background-repeat: no-repeat, no-repeat;
    background-size: auto 30px, auto 100%;

    &::before {
        position: absolute;
        z-index: -1;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background-image: $normal-bg;
        content: "";
    }

    &._live::before {
        background-image: $live-bg;
    }
}
</style>
